import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark text-white mt-5 py-4">
      <Container>
        <Row>
          <Col md={4}>
            <h5>{t('footer.title')}</h5>
            <p>
              {t('footer.organization')}
            </p>
            <p>
              {t('footer.location').split('\n').map((line, i) => (
                <span key={i}>{line}<br /></span>
              ))}
            </p>
          </Col>
          <Col md={4}>
            <h5>{t('footer.quick_links')}</h5>
            <ul className="list-unstyled">
              <li><a href="/" className="text-white">{t('home')}</a></li>
              <li><a href="/about" className="text-white">{t('about_us')}</a></li>
              <li><a href="/causes" className="text-white">{t('causes')}</a></li>
              <li><a href="/contact" className="text-white">{t('contact_us')}</a></li>
              <li><a href="/donate" className="text-white">{t('donate')}</a></li>
            </ul>
          </Col>
          <Col md={4}>
            <h5>{t('footer.our_mission_title')}</h5>
            <p>
              {t('footer.our_mission_text')}
            </p>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col className="text-center">
            <p>&copy; {currentYear} {t('footer.copyright')}</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
